import { useEffect, useState } from 'react';
import './communication.css';
import ImageModal from "./ImageModal";
import { getS3Media } from '../../services/awsServices';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import AudioPlayer from '../Players/AudioPlayer';
import VideoPlayer from '../Players/VideoPlayer';

// const imageExtensions = ["jpg", "jpeg", "png", "gif", "tiff", "bmp", "svg", "webp", "ico", "heif", "heic"];

const fileDisplayComponents = {
    image: ({ file }) => <img src={file.url} alt="preview" className="w-[100px] h-[100px] rounded-md" />,
    // pdf: ({ file }) => (
    //     <iframe src={`https://docs.google.com/viewer?url=${encodeURIComponent(file.url)}&embedded=true`} width="100%" height="500px" frameBorder="0">
    //         This browser does not support PDFs. Please download the PDF to view it: <a href={file.url}>Download PDF</a>.
    //     </iframe>
    // ),
    audio: ({ file }) => <AudioPlayer src={file.url} className="w-[323px]" />,
    video: ({ file }) => <VideoPlayer src={file.url} className="w-[323px]" />,
    default: ({ file, index }) => (<CustomTooltip title="Click here to download this file">
                                    <div key={index} className="file-container cursor-pointer bg-pureWhite p-2 rounded-md hover:bg-white" onClick={() => handleFileClick(index)}>
                                        <p className='text-darkOrange text-lg font-bold'>Attachment</p>
                                        <p className="file-name text-darkOrange">{file.name}</p>
                                    </div>
                                   </CustomTooltip>)
};

const getFileType = (fileName) => {
    const extension = fileName.split(".").pop().toLowerCase();
    if (["jpg", "jpeg", "png", "gif", "tiff", "bmp", "svg", "webp", "ico", "heif", "heic"].includes(extension)) return 'image';
    // if (extension === 'pdf') return 'pdf';
    if (["mp3", "wav", "ogg"].includes(extension)) return 'audio';
    if (["mp4", "webm", "ogg"].includes(extension)) return 'video';
    if (extension === 'txt') return 'text';
    return 'default';
};

const AttachmentDisplay = ({ files=[] }) => {
    const [previewFiles, setPreviewFiles] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalStartIndex, setModalStartIndex] = useState(0);

    // const getImageOrFilesFromS3 = async (images) => {
    //     const promises = [];
    //     for (let i = 0; i < images.length; i++) {
    //         const fileName = images[i];
    //         promises.push(getS3Media(fileName));
    //     }

    //     const files = await Promise.all(promises);
    //     // console.log(files, "===fillleeeessssssssssssssssssssss");
    //     const allFilesUrl = files.map(file => file.data.url);
    //     setPreviewImages(allFilesUrl);
    // }

    const fetchMediaFromS3 = async (fileNames) => {
        const promises = fileNames.map((fileName) => getS3Media(fileName));
        const filesData = await Promise.all(promises);
        const filesWithUrls = filesData.map((file, index) => ({
            url: file.data.url,
            type: getFileType(fileNames[index]),
            name: fileNames[index],
        }));
        console.log(filesWithUrls, "===fileeeeeessssssssssssssssss");
        setPreviewFiles(filesWithUrls);
    };

    useEffect(()=>{
        fetchMediaFromS3(files)
    }, []);
  
    const handleFileClick = (index) => {
        const file = previewFiles[index];
        const fileType = file.type;
        
        if (fileType === 'image') {
            setIsModalOpen(true);
            setModalStartIndex(index);
        } else {
            const link = document.createElement('a');
            link.href = file.url;
            link.download = file.name;
            link.click();
            link.remove();
        }
    };

    const renderFilePreview = (file, index) => {
        const FileComponent = fileDisplayComponents[file.type] || fileDisplayComponents.default;
        return (
            <div key={index} className="file-container cursor-pointer relative" onClick={() => handleFileClick(index)}>
                <FileComponent file={file} index={index} />
                {index === 3 && previewFiles.length > 4 && (
                    <div className="image-overlay">+{previewFiles.length - 4}</div>
                )}
            </div>
        );
    };

    return (
        <div>
            <div className="attachments-preview-container mt-2 flex gap-2">
                {previewFiles.slice(0, 4).map(renderFilePreview)}
            </div>
            <ImageModal isOpen={isModalOpen} images={previewFiles.map(file => file.url)} onClose={() => setIsModalOpen(false)} initialIndex={modalStartIndex} />
        </div>
    );
  
    return (
      <div>
        <div className="attachments-preview-container mt-2 flex gap-2">
            {previewFiles.slice(0, 4).map((file, index) => (
                file.type === 'image' ? (
                    <div key={index} className="image-container cursor-pointer" onClick={() => handleFileClick(index)}>
                        <img src={file.url} alt={`Preview ${file.name}`} className="w-[100px] h-[100px] rounded-md" />
                        {index === 3 && previewFiles.length > 4 && (
                            <div className="image-overlay">+{previewFiles.length - 4}</div>
                        )}
                    </div>
            ) : (
                <CustomTooltip title="Click here to download this file">
                    <div key={index} className="file-container cursor-pointer bg-pureWhite p-2 rounded-md hover:bg-white" onClick={() => handleFileClick(index)}>
                        <p className='text-darkOrange text-lg font-bold'>Attachment</p>
                            <p className="file-name text-darkOrange">{file.name}</p>
                    </div>
                </CustomTooltip>
            )
            ))}
        </div>
        <ImageModal isOpen={isModalOpen} images={previewFiles.map(file => file.url)} onClose={() => setIsModalOpen(false)} initialIndex={modalStartIndex} />
        {/* <div className="images-preview-container mt-2">
          {previewFiles.slice(0, 4).map((image, index) => {
            const extension = image.split(".")[image.split(".").length - 1];
            if(imageExtensions.includes(extension)){ 
                return (
                    <div key={index} className="image-container cursor-pointer" onClick={() => handleImageClick(index)}>
                    <img src={image} alt={`preview ${index}`} className={`w-[100px] h-[100px] rounded-md`} />
                    {index === 3 && previewImages.length > 4 && (
                        <div className="image-overlay">+{previewImages.length - 4}</div>
                    )}
                    </div>
                )}
          })}
        </div>
        <ImageModal isOpen={isModalOpen} images={previewImages} onClose={() => setIsModalOpen(false)} initialIndex={modalStartIndex} /> */}
      </div>
    );
};


export default AttachmentDisplay;  